// === SAA:UI:SUBSCRIPTION-CARD ===
// "Meer dan alleen verzekerd" sidebar card: what the DFD serviceabonnement adds, with the
// entry price (tier1 incl. its 5% tax: the same amount the premium card's fee row shows for
// 1-2 products). Renders nothing when the fee is disabled for the brand.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useConfig, formatPrice } from '@sluitstraat/core';
import { commonStyles } from '../styles/commonStyles';
import { CheckBulletList } from './CheckBulletList';
import { subscriptionEntryFee } from '../utils/subscriptionFee';

export const SubscriptionCard: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  const { config } = useConfig();
  const fromFee = subscriptionEntryFee(config);
  if (!fromFee) return null;

  return (
    <div style={commonStyles.helpCard} className={className}>
      <p style={commonStyles.eyebrowLabel}>{t('sidebar.subscription.eyebrow')}</p>
      <h3 style={commonStyles.helpTitle}>{t('sidebar.subscription.title')}</h3>
      <CheckBulletList items={[1, 2, 3, 4, 5].map((n) => t(`sidebar.subscription.item${n}`))} />
      <div style={commonStyles.subscriptionPrice}>
        <span style={commonStyles.subscriptionPriceAmount}>
          {t('sidebar.subscription.from', { amount: formatPrice(fromFee) })}
        </span>
        <span style={commonStyles.subscriptionPriceNote}>{t('sidebar.subscription.fromNote')}</span>
      </div>
    </div>
  );
};

export default SubscriptionCard;
